var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMarketPlace = function SvgMarketPlace(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    clipPath: "url(#marketPlace_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 11.418s2.502-1.069 4.587-1.069c1.471 0 3.086.591 4.168 1.079.83.374 1.307.61 1.497 1.5.132.618-.312 1.65-.942 1.7l-.444.036m0 0c-1.019 0-2.595-.302-2.595-.302m2.595.302c1.412 0 5.13-.671 6.448-.917.314-.059.64-.102.939.01.376.143.88.486 1.122 1.315.188.647-.264 1.27-.893 1.512-1.843.714-5.687 2.105-7.616 2.105C4.753 18.69 1 17.406 1 17.406M9.344 5.762c0 3.852 4.17 6.26 7.506 4.334a5 5 0 0 0 2.502-4.334c0-3.853-4.17-6.26-7.506-4.334a5 5 0 0 0-2.502 4.334"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.016 4.042s-.667-.47-1.668-.47c-.834 0-1.668.47-1.668 1.095 0 1.564 3.336.626 3.336 2.19 0 .625-.834 1.094-1.668 1.094-1.001 0-1.668-.47-1.668-.47M14.344 3.572v-.73M14.344 8.68v-.729"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "marketPlace_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgMarketPlace;